import { Button, Modal } from '@next-nx/shared-ui/atoms'
import { useTrans } from '@next-nx/hooks'
import React from 'react'
import styles from './NewsletterThankYouModal.module.sass'

interface Props {
  open: boolean
  setOpen: (v: boolean) => void
  status: string | undefined
  className?: string
}

const NewsletterThankYouModal = (props: Props) => {
  const { open = false, setOpen = undefined, status = undefined, className = '' } = props

  const t = useTrans()

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      closeButton
      title={
        status === 'error'
          ? t("C'è stato un errore nell'iscrizione alla newsletter")
          : t('Ci sentiamo presto!')
      }
      description={
        status === 'error'
          ? t("Ci scusiamo per il disagio, ti invitiamo a riprovare più tardi.")
          : t(
              'Riceverai la prossima newsletter direttamente nella tua casella di posta.'
            )
      }
      buttons={<Button label={t('Chiudi')} onClick={() => setOpen(false)} />}
      className={`${styles.root} ${className}`}
    />
  )
}

export default NewsletterThankYouModal
